
import React from 'react';
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import CompanyPage from '../pages/company/page';
import OverviewPage from '../pages/overview/page';
import SmartPBDPage from '../pages/smart-pbd/page';
import SmartDCMPage from '../pages/smart-dcm/page';
import GNSSSettlementPage from '../pages/gnss-settlement/page';
import CasesPage from '../pages/cases/page';
import MaterialsPage from '../pages/materials/page';
import ContactPage from '../pages/contact/page';
import NotFoundPage from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/company',
    element: <CompanyPage />
  },
  {
    path: '/overview',
    element: <OverviewPage />
  },
  {
    path: '/smart-pbd',
    element: <SmartPBDPage />
  },
  {
    path: '/smart-dcm',
    element: <SmartDCMPage />
  },
  {
    path: '/gnss-settlement',
    element: <GNSSSettlementPage />
  },
  {
    path: '/cases',
    element: <CasesPage />
  },
  {
    path: '/materials',
    element: <MaterialsPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
